<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基础配置</span>
        </div>

        <el-form ref="formData" :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="ID">
              <el-input v-model.number="item.id" readonly style="width: 100px;" placeholder="ID" />
            </el-form-item>
            <el-form-item label="游戏ID">
              <el-input v-model.number="item.gameid" style="width: 100px;" placeholder="游戏ID" />
            </el-form-item>
            <el-form-item label="Key">
              <el-input v-model="item.key" style="width: 100px;" placeholder="Key" />
            </el-form-item>
            <el-form-item label="Value">
              <el-input v-model="item.value" style="width: 100px;" placeholder="Value" />
            </el-form-item>
            <el-form-item label="mark">
              <el-input v-model="item.mark" style="width: 100px;" placeholder="标识" />
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:baseCfg:del']" type="danger" @click="del(index, item.id)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:baseCfg:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-if="formData.length > 0" v-permisaction="['config:baseCfg:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { delBaseCfg, getBaseCfgList, updateBaseCfg } from '@/api/config/base-cfg'
export default {
  name: 'BaseConfig',
  data() {
    return {
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      formData: [
        {
          'id': 0,
          'gameid': 0,
          'key': '',
          'value': '',
          'mark': ''
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      let isValidate = true
      this.formData.forEach((item) => {
        if (item.key === '') {
          this.msgError('key 不能为空')
          isValidate = false
        }

        if (item.value === '') {
          this.msgError('value 不能为空')
          isValidate = false
        }
      })

      if (!isValidate) {
        return false
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateBaseCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getBaseCfgList(this.queryParams).then(res => {
        this.formData = res.data.list
        this.total = res.data.count
      })
    },
    add() {
      this.formData.push({
        'id': 0,
        'gameid': 0,
        'key': '',
        'value': '',
        'mark': ''
      })
    },
    del(key, id) {
      console.log('delete id', id)
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delBaseCfg({ id: id }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        })
      }
      this.formData = this.formData.filter((item, index) => {
        return index !== key
      })
    }
  }
}
</script>

<style scoped>
</style>
